import React from 'react';
import "./index.scss";

class PageBlank extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div>
                    ok bangladesh
                </div>

            </React.Fragment>
        );
    }
}


export default PageBlank;